//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from "../other/Button";
import PatronAvatar from "./PatronAvatar";

export default {
  components: {
    Button,
    PatronAvatar
  },
  props: {
    myProfileData: {
      type: Object,
      default: () => {}
    },
    masterpieceId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      email: '',
      disabled: false,
      formError: null,
      anonymous: false
    }
  },
  computed: {
  },
  methods: {
    sendForm(confirm) {
      this.disabled = true
      this.$axios({
        method: 'post',
        url: `/api/v1/patronage/setGift`,
        data: `lang=${this.$i18n.locale || 'ru'}&confirm=${confirm}&id=${this.masterpieceId}&anonymous=${this.anonymous}`
      })
        .then(({data}) => {
          if (data.error) {
            this.formError = data.error.message
            this.disabled = false
          } else {
            if (confirm) {
              this.$router.push(`/profile/detail?masterpieceId=${this.masterpieceId}&gpbPatronPaymentStatus=success&ignoreApi=true`)
            }
            this.$store.commit('forms/changeIdForPatronForm')
          }
        })
        .catch(err => {
          this.formError = err.message
          this.disabled = false
        })
    }
  }
}
